import { action, makeObservable, onBecomeObserved } from "mobx"

import { transactionsSwapFilters } from "@src/pages/transactionsSwap/constants"
import { convertsApi } from "@src/shared/api"
import { ConvertResponse, Pagination } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"
import { wrapSingleton } from "@src/shared/classes/utils/wrapSingleton"
import { CollectionFilters } from "@src/shared/componemts/TableFilter/classes/CollectionFilters"

export type ConvertsCollectionLoadRequest = {
  id: string
  order?: "asc" | "desc"
  page?: number
  status?: "failed" | "pending" | "success"
}

export type ConvertsCollectionFilters = {
  order?: "asc" | "desc"
  status?: "failed" | "pending" | "success"
}

export class ConvertsCollection extends loading(
  ["fetch"],
  CollectionWithPagination<ConvertResponse>,
) {
  constructor() {
    super()

    makeObservable(this, { fetch: action.bound })

    onBecomeObserved(this, "isLoading", this.load)
  }

  async fetch(
    req: ConvertsCollectionLoadRequest,
  ): Promise<{ data: ConvertResponse[]; pagination: Pagination } | null> {
    try {
      const {
        data: { data },
      } = await convertsApi.getConverts(
        req.order,
        this.pageSize,
        this.calcOffset(req.page ?? 0),
        req.status,
        req.id,
      )

      if (data) {
        return {
          data: data.data!,
          pagination: data.pagination!,
        }
      }
    } catch (catchErrors) {}

    return null
  }

  async getById(id: string) {
    const found = this.items.find((item) => item.id === id)

    if (found) {
      return found
    }

    const data = await this.fetch({ id })

    if (data) {
      const { data: items } = data

      return items[0]
    }

    return undefined
  }

  get filter() {
    return new CollectionFilters<ConvertsCollectionFilters>(
      [
        CollectionFilters.createField("id").search({
          col: 6,
          label: "ID",
          placeholder: "Search by ID",
        }),
        ...transactionsSwapFilters,
      ],
      this.load,
    )
  }
}

export const GlobalSwapsCollection = wrapSingleton(ConvertsCollection)
